<button #originRef (click)="showPopover()" [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon [icIcon]="icNotificationsActive"></mat-icon>
</button>